import React, { useState } from 'react'
import './FAQ.css'
import Common_Banner_2 from '../common_components/common_banner_2/Common_Banner_2'
import Breadcrumb_comp from '../common_components/breadcrumb-comp/Breadcrumb_comp';
import { Accordion } from 'react-bootstrap';
import { faAngleDown, faAngleUp } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const FAQ = () => {

    const breadcrumbs = [
        { label: "Home", link: "/", isActive: false },
        { label: "FREQUENTLY ASKED QUESTIONS", link: "", isActive: true },
    ];


    const [activeKey, setActiveKey] = useState("0");

    return (
        <section className='FAQ'>
            <Common_Banner_2
                imgSrc={"/assets/images/faq/bg.png"}
                title_text="Frequently Asked Questions"
            />

            <div className='container'>
                {/* <div className='top_div'>
                    <Breadcrumb_comp breadcrumbs={breadcrumbs} />
                </div> */}

                <div className='faq_div'>
                    <Accordion activeKey={activeKey} onSelect={(key) => setActiveKey(key)}>
                        {[0, 1, 3, 4].map((key) => (
                            <Accordion.Item eventKey={key.toString()} key={key}>
                                <Accordion.Header>
                                    <p className="question_text">
                                      I'm planning to renovate my home. How do I start working with TECH Interiors & Designers? What's the first step?
                                    </p>

                                    <div className="icon_holder">
                                        <FontAwesomeIcon
                                            icon={activeKey === key.toString() ? faAngleUp : faAngleDown}
                                            className="icon_text"
                                        />
                                    </div>
                                </Accordion.Header>
                                <Accordion.Body>
                                    <div className='answer_div'>
                                        <p className='faq_answer_text'>
                                         The best way to start is to contact us directly! You can call us at [Your Phone Number], email us at info@techinteriors.com, or fill out the "Request a Quote" form on our website. We'll schedule an initial consultation to discuss your project needs and how we can assist.
                                        </p>
                                    </div>
                                </Accordion.Body>
                            </Accordion.Item>
                        ))}
                    </Accordion>
                </div>

            </div>



        </section>
    )
}

export default FAQ
